import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

const store = new Vuex.Store({
  state: {
    responseType: null,
    userDiscount: 0,
    facetData: [],
    activeFacetsData: [],
    taps: [],
    productsList: [],
    childrenCategoriesList: [],
    activeFiltersCounter: 0,
    searchQuery: '',
  },

  mutations: {
    INIT_PAGE_DATA(state, {
      facet, selectedFacets, taps, products,
    }) {
      if (facet) state.facetData = facet;
      if (selectedFacets) state.activeFacetsData = selectedFacets;
      if (taps) state.taps = taps;
      if (products) state.productsList = products;
    },
    SET_USER_DISCOUNT(state, payload) {
      state.userDiscount = payload;
    },
    SET_FACET_DATA(state, payload) {
      state.facetData = payload;
    },
    SET_ACTIVE_FACETS_DATA(state, payload) {
      state.activeFacetsData = payload;
    },
    SET_TAPS(state, payload) {
      state.taps = payload;
    },
    SET_PRODUCTS_LIST(state, payload) {
      state.productsList = payload;
    },
    ADD_MORE_PRODUCTS(state, payload) {
      state.productsList.push(...payload);
    },
    SET_CHILDREN_CATEGORIES(state, payload) {
      state.childrenCategoriesList = payload;
    },
    CHANGE_ACTIVE_FILTERS_COUNTER(state, payload) {
      state.activeFiltersCounter = payload;
    },
    SET_SEARCH_QUERY(state, payload) {
      state.searchQuery = payload;
    },
    SET_RESPONSE_TYPE(state, payload) {
      state.responseType = payload;
    },
  },

  getters: {
    activeCategoryName(state) {
      return state.activeFacetsData.find((el) => el.name === 'categories')?.values[0].name || '';
    },
    itemsCount(state) {
      if (!state.facetData.length) return null;

      const categoriesFacet = state.facetData.find((el) => el.name === 'categories');
      if (categoriesFacet) {
        return categoriesFacet.values.reduce((acc, item) => acc + item.value, 0);
      }

      return null;
    },
    isEmptyResponseType(state) {
      return state.responseType === 'empty';
    },
    isAnalogResponseType(state) {
      return state.responseType === 'analog';
    },
    isFoundResponseType(state) {
      return state.responseType === 'found';
    },
  },
});

export default store;
